import React from "react";
import { observer } from "mobx-react-lite";

import { HeaderContainer } from "Views/Shared/Views/SessionReport/SessionReport.styles";
import { StudentSessionAQACertificatesViewModel } from "./StudentSessionAQACertificatesViewModel";
import { Box, Button, Label, theme } from "Application";
import { StudentSessionAQACertificateTableView } from "./Shared/StudentSessionAQACertificateTableView";
import { AddEditAQAStudentSessionModal } from "./Modals/AddEditAQAStudentSessionModal";
import { WarningModal } from "Views/Students/Shared/Modals/WarningModal";
interface IStudentSessionAQACertificatesViewProps {
    viewModel: StudentSessionAQACertificatesViewModel | null;
}

export const StudentSessionAQACertificatesView: React.FC<IStudentSessionAQACertificatesViewProps> = observer(({ viewModel }) => {
    if (!viewModel) return <></>;
    return (
        <>
            <Box flexBox flexDirection={"column"} borderTop="1px solid #D4D4D4" borderBottom="1px solid #D4D4D4" p={"25px 0px"} gap="20px">
                <HeaderContainer>
                    <Box display={"flex"} flexDirection={"column"} style={{ gap: "10px" }}>
                        <Label fontStyle={"h2"}>AQA certificates</Label>
                        {!viewModel.showTable && <Label fontStyle="p">There are currently no AQA certificates added to this session.</Label>}
                    </Box>
                    <Button command={viewModel.addStudentSessionAQACertificateCommand} displayName={"Add AQA Certificate"} paletteColor="primary" />
                </HeaderContainer>

                {viewModel.showTable && (
                    <StudentSessionAQACertificateTableView
                        onRemoveRowCommand={viewModel.deleteStudentSessionAQACertificateCommand}
                        onRowEditCommand={viewModel.editStudentSessionAQACertificateCommand}
                        data={viewModel.certificates}
                    />
                )}
            </Box>
            {/* Modals */}
            <AddEditAQAStudentSessionModal
                viewModel={viewModel._AQACertificateToAdd}
                onConfirmCommand={viewModel.confirmStudentSessionAQAAddCommand}
                onCloseCommand={viewModel.cancelAddCommand}
            />
            <AddEditAQAStudentSessionModal
                viewModel={viewModel._AQACertificateToEdit}
                onConfirmCommand={viewModel.confirmStudentSessionAQAEditCommand}
                onCloseCommand={viewModel.cancelEditCommand}
            />
            <WarningModal
                isOpen={viewModel.showDeleteModal}
                onClose={viewModel.cancelDeleteCommand}
                onCloseButtonText="Cancel"
                onConfirmButtonText="Confirm"
                onConfirm={viewModel.confirmStudentSessionAQADeleteCommand}
                warningMessage={"You are about to delete a AQA certificate. Are you sure you want to continue?"}
            />
        </>
    );
});
